import { ComponentProps, useCallback, useContext, useMemo } from 'react';
import { useActivePosEntityContext } from 'src/contexts/ActivePosEntityContext';
import { Content } from 'src/contexts/ContentContext';
import { ModalContext } from 'src/contexts/ModalContext';
import { HistoryIcon } from 'src/svgs/HistoryIcon';
import { IconsFill } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';

import { ModalProps } from '../Modal';
import { ActivityLogModal } from './ActivityLogModal';
import * as styles from './ActivityLogModal.css';
import { ActivityLogLaunchButtonIconSpan } from './ActivityLogModal.styled';

export const LaunchActivityLog = ({
  entityId,
  cancelTo,
}: {
  entityId: number;
} & ComponentProps<typeof ActivityLogModal>) => {
  const { setModal, currentModalConfig } = useContext(ModalContext);
  const { setActivePosEntity } = useActivePosEntityContext();

  // Use the current modal config as cancelTo so the activity log
  // navigates back to whatever modal was showing (e.g. barcode modal),
  // rather than always going to the listing details modal.
  const activityLogCancelTo = useMemo(() => {
    if (!currentModalConfig) return cancelTo;
    // Exclude onCloseOverride as it contains stale closures from the
    // current modal's CancellableFormHeader and will be re-set on mount.
    const { onCloseOverride, ...config } = currentModalConfig;
    return config as ModalProps;
  }, [currentModalConfig, cancelTo]);

  const activityLogUi = useCallback(() => {
    setModal({
      children: <ActivityLogModal cancelTo={activityLogCancelTo} />,
      clickOutsideToClose: false,
      size: 'slide-in',
    });
  }, [setModal, activityLogCancelTo]);

  const onLaunchDialog = useCallback(() => {
    setActivePosEntity(entityId, undefined, true);
    activityLogUi();
  }, [setActivePosEntity, entityId, activityLogUi]);

  return (
    <div className={styles.activityLogLaunchButtonIconContainer}>
      <ActivityLogLaunchButtonIconSpan onClick={onLaunchDialog}>
        <HistoryIcon
          withHoverEffect={true}
          fill={IconsFill.currentColor}
          style={{ verticalAlign: 'middle' }}
        />
        <Content id={ContentId.ActivityLogLaunchButtonText} />
      </ActivityLogLaunchButtonIconSpan>
    </div>
  );
};
